import { cheminSansLangue } from "~/utils/langue";

/**
 * Chemin de la page courante SANS préfixe de langue (cf. utils/langue.ts).
 * « /en/c/ramadan » → « /c/ramadan ».
 */
export function useCheminSansLangue() {
  const route = useRoute();
  return computed(() => cheminSansLangue(route.path));
}
